const sha1 = require('sha1');

export default {
  sha1Password(password) {
    return `*${sha1(sha1(password, { asBytes: true }))}`;
  },
  setModelsToBody(body, state) {
    let id = '';
    let address = {};
    let mobile = {};
    state.models.forEach((element) => {
      let birthDay = '';
      switch (element.modelID) {
        case 'Address':
          address = state.answers.find((d) => d.id === element.modelID).value;
          if (address.zipCode.toString()) {
            body.zipCode = parseInt(address.zipCode, 10);
          } else {
            body.zipCode = 0;
          }
          body.country = address.country;
          body.province = address.province;
          body.city = address.city;
          body.district = address.district;
          body.address = address.address;
          break;
        case 'Mobile':
          mobile = state.answers.find((d) => d.id === element.modelID).value;
          body.mobileCountry = mobile.mobileCountry.toString();
          body.callingCode = mobile.callingCode.toString();
          body.mobile = mobile.mobile.toString();
          break;
        case 'Name':
          body.realName = state.answers.find((d) => d.id === element.modelID).value;
          break;
        case 'Nickname':
          body.name = state.answers.find((d) => d.id === element.modelID).value;
          break;
        case 'EMail':
          body.email = state.answers.find((d) => d.id === element.modelID).value;
          break;
        case 'Birthday':
          birthDay = state.answers.find((d) => d.id === element.modelID).value;
          if (birthDay) {
            body.birth = birthDay;
          } else {
            body.birth = '1900-01-01';
          }
          break;
        case 'Password':
          if (!state.trdLoginData) {
            body.password = state.password;
            body.accountType = state.accountType;
          }
          break;
        case 'PasswordReset':
          if (state.updatePassword) {
            body.password = state.password;
            body.accountType = state.accountType;
          }
          break;
        default:
          id = element.modelID.substring(0, 1).toLowerCase() + element.modelID.substring(1, element.modelID.length);
          if (state.answers.find((d) => d.id === element.modelID)) {
            body[id] = state.answers.find((d) => d.id === element.modelID).value;
          }
          break;
      }
    });
    body.custom = [];
    state.customModels.forEach((element) => {
      if (state.customAnswers.find((d) => d.customQuestionID === element.customQuestionID)) {
        body.custom.push({
          customQuestionID: element.customQuestionID,
          paramValue: state.customAnswers.find((d) => d.customQuestionID === element.customQuestionID).paramValue,
        });
      }
    });
  },
};
